export default "__VITE_ASSET__Dt6o5GCw__"